import React, { createContext, useContext, useState, useEffect } from 'react';

const ProfileImageContext = createContext();
const authNData = localStorage.getItem('auth');
const userAid = authNData ? JSON.parse(authNData).id : null;
export const ProfileImageProvider = ({ children }) => {
  const [profileImage, setProfileImage] = useState(localStorage.getItem('profileImage' + userAid) || null);

  useEffect(() => {
    const savedImage = localStorage.getItem('profileImage' + userAid);
    if (savedImage) {
      setProfileImage(savedImage);
    }
  }, []);

  return (
    <ProfileImageContext.Provider value={{ profileImage, setProfileImage }}>
      {children}
    </ProfileImageContext.Provider>
  );
};

export const useProfileImage = () => useContext(ProfileImageContext);
